import React, { useEffect, useState } from 'react';
import { motion, useAnimation, useScroll, useTransform } from 'framer-motion';
import arsal from "../img/a-3d-render-of-youssef-a-17-year-old-medium-height-MtupzEk7RmyjJd0lDp0EVA-ziAOKGqtTEaOeGUijfq_Cw-removebg.png";
import Card from './Card';

const steps = [
  { text: "Developer", duration: 2000 },
  { text: "Designer", duration: 2000 },
  { text: "Author", duration: 2000 }
];

const Home = (props) => {
  const controls = useAnimation();
  const [index, setIndex] = useState(0);
  const [isParallaxEnabled, setIsParallaxEnabled] = useState(true);

  const { scrollYProgress } = useScroll();
  const imageY = useTransform(scrollYProgress, [0, 1], ["0%", "-90%"]); // Y position for the image
  const circleScale = useTransform(scrollYProgress, [0, 1], [1, 5.5]); // Scale for the circle

  // Disable parallax on screens smaller than 768px
  useEffect(() => {
    const handleResize = () => {
      setIsParallaxEnabled(window.innerWidth >= 768);
    };
    handleResize(); // Run on initial load
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const cycleText = () => {
      controls.start({ opacity: 0, transition: { duration: 0.5 } }).then(() => {
        setIndex((prev) => (prev + 1) % steps.length);
        controls.start({ opacity: 1, transition: { duration: 0.5 } });
      });
    };

    const interval = setInterval(cycleText, steps[index].duration);
    return () => clearInterval(interval);
  }, [controls, index]);

  return (
    <div className="relative h-screen overflow-hidden">
      {/* Parallax Image */}
      <motion.img
        style={isParallaxEnabled ? { y: imageY } : { y: 0 }} // Apply the Y transform
        initial={{ opacity: 0, y: 50 }} // Initial position
        animate={{ opacity: 1, y: 0 }} // Animate to visible
        transition={{ duration: 1 }}
        className="absolute bottom-0 right-0 lg:left-0 mx-auto h-5/6 object-cover"
        src={arsal}
        alt="my-Image"
      />

      {/* Parallax Circle */}
      <motion.div
        className={`hidden lg:block absolute -bottom-1/4 right-0 left-0 mx-auto h-big w-big ${props.darkMode ? 'dark:bg-orange-900' : 'bg-purple-800'} rounded-full -z-10`}
        style={isParallaxEnabled ? { scale: circleScale } : { scale: 1 }} // Apply scale
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ duration: 2 }}
      />

      {/* Animated Text with Cycling Titles */}
      <div className="absolute top-1/3 left-5 text-xl sm:left-10 sm:text-4xl md:left-1/4 md:text-6xl lg:left-5 xl:left-44 xl:text-7xl">
        <span className="text-gray-600 font-bold">Freelance </span>
        <motion.p
          initial={{ opacity: 0 }}
          animate={controls}
          className={props.darkMode?'text-lime-300':'text-rose-700'}
          style={{ position: "relative" }}
        >
          {steps[index].text}
        </motion.p>
      </div>

      {/* Glassmorphism Card */}
      <Card darkMode={props.darkMode} />
    </div>
  );
};

export default Home;
